import { IPolicyType } from '../../redux/slices/PolicySlice/types';

export const POLICY_TYPE: IPolicyType[] = ['GMC', 'GPA', 'GTL', 'COVID'];

export const DATE_FIELDS = ['policyStartDate', 'policyEndDate', 'paymentDate', 'createdAt', 'updatedAt'];
